import { apiSlice } from "../apiSlice";
import { API } from "../../../globals/globals";

export interface IGoldenAuditViolation {
  id: number;
  deviceKey: string;
  datamodelKey: string;
  expectedValue: string;
  actualValue: string;
  definitionId?: number;
  radioTech: string;
  lastRunAt: number;
  rule?: {
    id: number;
    keyPattern: string;
    expectedValue: string;
    permission: string;
    gsVersion: string;
    enabled: boolean;
    notes: string;
    definition?: {
      id: number;
      templatename?: string;
      description?: string;
      nodeType?: string;
      radioTech?: string;
      version?: string;
      createdByUserId?: string;
      createdAt?: number;
      updatedAt?: number;
      scopeType?: string;
      scheduleEnabled?: boolean;
      scheduleIntervalMinutes?: number;
      scheduleStartTime?: number;
      lastScheduledRunAt?: number;
    };
  };
}

export const goldenAuditViolationsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getViolationsForDevice: builder.query<IGoldenAuditViolation[], { deviceKey: string; radioTech?: string }>({
      query: ({ deviceKey, radioTech }) => {
        let url = `${API.ENDPOINTS.GOLDEN_AUDIT_VIOLATIONS.path}/devices/${deviceKey}/violations`;
        if (radioTech) url += `?radioTech=${encodeURIComponent(radioTech)}`;
        return { url };
      },
    }),
    exportCorrectiveTemplate: builder.mutation<any, { definitionId: number; deviceKey: string }>({
      query: ({ definitionId, deviceKey }) => ({
        url: `${API.ENDPOINTS.GOLDEN_AUDIT_VIOLATIONS.path}/templates/${definitionId}/export/device?deviceKey=${encodeURIComponent(deviceKey)}`,
        method: "GET",
        headers: {
          "Content-Type": "application/xml",
        },
      }),
    }),
    createLocalCorrectiveTemplate: builder.mutation<string, { definitionId: number; deviceKey: string }>({
      query: ({ definitionId, deviceKey }) => ({
        url: `${API.ENDPOINTS.GOLDEN_AUDIT_VIOLATIONS.path}/templates/${definitionId}/create-local?deviceKey=${encodeURIComponent(deviceKey)}`,
        method: "POST",
        responseHandler: "text",
      }),
    }),
    runAuditForDevice: builder.mutation<void, { definitionId: number; deviceKey: string }>({
      query: ({ definitionId, deviceKey }) => ({
        url: `${API.ENDPOINTS.GOLDEN_AUDIT_VIOLATIONS.path}/templates/${definitionId}/run/device?deviceKey=${encodeURIComponent(deviceKey)}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetViolationsForDeviceQuery,
  useExportCorrectiveTemplateMutation,
  useCreateLocalCorrectiveTemplateMutation,
  useRunAuditForDeviceMutation,
} = goldenAuditViolationsApiSlice;
